var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/core-js/library/modules/_has.js
// module id = ../../node_modules/core-js/library/modules/_has.js
// module chunks = 1